import { FC } from 'react';

import { ExploreNfts } from '../../containers';

export const Explore: FC = () => {
  return <ExploreNfts />;
};
